// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    color: black;
    border-top:0.5px solid gray;
}

footer {
    color: black;
    font-size: smaller;
    font-style: italic;
    text-align: center;
    margin-bottom: 10px;
}

.navbar-brand {
    display: inline-block;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
}


`, "",{"version":3,"sources":["webpack://./src/app/inside-of-application/home/home.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB","sourcesContent":[".fixed-bottom {\r\n    position: fixed;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    background-color: white;\r\n    color: black;\r\n    border-top:0.5px solid gray;\r\n}\r\n\r\nfooter {\r\n    color: black;\r\n    font-size: smaller;\r\n    font-style: italic;\r\n    text-align: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.navbar-brand {\r\n    display: inline-block;\r\n    padding-top: 0.3125rem;\r\n    padding-bottom: 0.3125rem;\r\n    margin-right: 1rem;\r\n    font-size: 1.25rem;\r\n    line-height: inherit;\r\n    white-space: nowrap;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
